// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:45:52

export default {
  "id": "homo-evolution",
  "slug": "homo-evolution",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6a4e00c9a7394f93bf6491a0dcf9a0b8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6a4e00c9a7394f93bf6491a0dcf9a0b8/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Homo Evolution",
      "description": "Create your own world and guide human evolution! Merge creatures, unlock eight evolution stages, and shape civilization from tiny spores to modern life. Explore new planets, experiment with unique paths, and enjoy endless fun in this captivating evolution game. Play now!",
      "instructions": "Explore each branch to open the next. By tapping the last two life forms at this stage, you get access to a new, previously unknown world!",
      "genres": [
        "Merge"
      ],
      "tags": [
        "clicker",
        "evolution",
        "idle",
        "singleplayer"
      ]
    },
    "zh-CN": {
      "title": "人类进化",
      "description": "创建你自己的世界，引导人类进化！融合生物，解锁八个进化阶段，将文明从微小的孢子塑造到现代生活。探索新星球，尝试独特的路径，在这款引人入胜的进化游戏中享受无尽的乐趣。现在就玩！",
      "instructions": "探索每个分支以开启下一阶段。通过点击当前阶段的最后两个生命体，您将获得进入一个全新、未知世界的权限！",
      "genres": [
        "合并"
      ],
      "tags": [
        "点击器",
        "进化",
        "休闲",
        "单人游戏"
      ]
    },
    "zh-TW": {
      "title": "人類進化",
      "description": "建立屬於你自己的世界，引導人類進化！合併生物，解鎖八個進化階段，從微小的孢子和現代生命塑造文明。探索新星球，嘗試獨特道路，享受這款迷人進化遊戲的無盡樂趣。現在就玩吧！",
      "instructions": "探索每個分枝以啟動下一階段。在這個階段，點擊最後兩個生命體，你將獲得進入一個全新、以前未知的世界的機會！",
      "genres": [
        "合併"
      ],
      "tags": [
        "點擊器",
        "進化",
        "閒置",
        "單人遊戲"
      ]
    },
    "zh-HK": {
      "title": "人類進化",
      "description": "創造你自己的世界，引導人類進化！合併生物，解鎖八個進化階段，從微小的孢子和現代生命塑造文明。探索新星球，嘗試獨特道路，享受這款吸引人的進化遊戲無盡的樂趣。立即遊玩！",
      "instructions": "探索每個分岔路以啟開下一個。在此階段輕觸最後兩種生命體，您將獲得進入一個新、前所未知的世界的權限！",
      "genres": [
        "合併"
      ],
      "tags": [
        "點擊器",
        "進化",
        "休閒",
        "單人遊戲"
      ]
    },
    "ja": {
      "title": "ホモ・エボリューション",
      "description": "自分自身の世界を創り出し、人類の進化を導こう！生物を融合させ、8つの進化段階を解禁し、小さな胞子から現代の生命体に至る文明を形作れ。新しい惑星を探検し、ユニークな進化経路を試み、魅力的な進化ゲームで無限の楽しみを堪能しよう！今すぐプレイ！",
      "instructions": "各枝分岐を探索して次の世界に進む。この段階で最後の二つの生命体をタップすることで、新たに未知の世界にアクセスすることができます！",
      "genres": [
        "合体"
      ],
      "tags": [
        "クリッカーレーサー",
        "進化",
        "インディー",
        "シングルプレイヤー"
      ]
    },
    "ko": {
      "title": "�omo 진화",
      "description": "자신만의 세상을 만들고 인간 진화를 이끌어보세요! 생물을 합성하고 8단계 진화 단계를 해금하고 작은 씨앗에서 현대 생명으로의 문명을 형성하세요. 새로운 행성을 탐험하고 독특한 경로를 실험하고 이 흥미진진한 진화 게임에서 끝없는 재미를 즐겨보세요. 지금 바로 플레이하세요!",
      "instructions": "각 가지를 탐험하여 다음 단계로 이동하세요. 이 단계에서 마지막 두 생명체를 탭하면 새로운, 이전에 알려지지 않은 세계에 접근할 수 있습니다!",
      "genres": [
        "정합"
      ],
      "tags": [
        "클릭러",
        "진화",
        "이드릴",
        "싱글플레이어"
      ]
    },
    "fr": {
      "title": "Homo Évolution",
      "description": "Créez votre propre monde et guidez l'évolution humaine ! Fusionnez des créatures, débloquez huit étapes d'évolution et façonnez la civilisation à partir de petites spores jusqu'à la vie moderne. Explorez de nouveaux mondes, expérimentez des chemins uniques et profitez d'un amusement infini dans ce jeu captivant d'évolution. Jouez maintenant !",
      "instructions": "Explorez chaque branche pour ouvrir la suivante. En tapant les deux dernières formes de vie à ce stade, vous accédez à un nouveau monde, inconnu jusqu'alors !",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "cliqueur",
        "évolution",
        "idle",
        "multijoueur simple"
      ]
    }
  }
};
